import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth-provider";

/**
 * Boot route: send authed users to /dashboard, everyone else to /auth.
 * The spinner is only visible for the very first frame while onAuthStateChanged fires.
 */
export default function Boot() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center bg-bg">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      </div>
    );
  }
  return <Navigate to={user ? "/dashboard" : "/auth"} replace />;
}
